import { Media } from '@gripp/shared-logic';
import { ImageGalleryImage } from '@gripp/shared-ui';
import { createContext } from 'react';

export type MediaExtended = Media & { isFromProduct?: boolean };

export type ThirdPanelMode = 'gallery' | 'filter' | 'video';

export type FilesContextType = {
  galleryImages: ImageGalleryImage[];
  setGalleryImages: (images: ImageGalleryImage[]) => void;
  galleryInitialIndex: number;
  setGalleryInitialIndex: (index: number) => void;
  thirdPanelMode: ThirdPanelMode;
  setThirdPanelMode: (mode: ThirdPanelMode) => void;
  allFiles: MediaExtended[];
  selectedCategoryId: string | undefined;
  setSelectedCategoryId: (id: string | undefined) => void;
  filterPanelRequested: boolean;
  setFilterPanelRequested: (requested: boolean) => void;
  videoMedia: Media | null;
  setVideoMedia: (media: Media | null) => void;
  isThirdPanelOpen: boolean;
  setIsThirdPanelOpen: (open: boolean) => void;
  isAddSheetOpen: boolean;
  setIsAddSheetOpen: (open: boolean) => void;
};

export const FilesContext = createContext<FilesContextType>({
  galleryImages: [],
  setGalleryImages: () => {},
  galleryInitialIndex: 0,
  setGalleryInitialIndex: () => {},
  thirdPanelMode: 'gallery',
  setThirdPanelMode: () => {},
  allFiles: [],
  selectedCategoryId: undefined,
  setSelectedCategoryId: () => {},
  filterPanelRequested: false,
  setFilterPanelRequested: () => {},
  videoMedia: null,
  setVideoMedia: () => {},
  isThirdPanelOpen: false,
  setIsThirdPanelOpen: () => {},
  isAddSheetOpen: false,
  setIsAddSheetOpen: () => {},
});
